import script from "./DataUpdateView.vue?vue&type=script&setup=true&lang=js"
export * from "./DataUpdateView.vue?vue&type=script&setup=true&lang=js"

import "./DataUpdateView.vue?vue&type=style&index=0&id=0bb87235&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bb87235"]])

export default __exports__